import { ZAROR_LOGO_PATH } from "./brandAssets";

const DEFAULT_SITE_URL = "https://zaror.co.uk";

export function getSiteUrl() {
  if (process.env.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL.replace(/\/$/, "");
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return DEFAULT_SITE_URL;
}

export function getSiteLogoUrl() {
  return `${getSiteUrl()}${ZAROR_LOGO_PATH}`;
}
